module.exports = __webpack_public_path__ + "static/media/sl_marker_police_selected.a23cd67e.svg";